<template>
  <transition name="fade">
    <div  v-if="isVisible" class="toast-container">
      <span class="toast-text">{{ message }}</span>
    </div>
  </transition>
</template>

<script setup>
  import { ref } from 'vue'

  const props = defineProps({
    duration: {
      type: Number,
      default: 3000
    }
  })

  const isVisible = ref(false)
  const message = ref('')

  let timer = null

  const show = (msg, duration = props.duration) => {
    if (timer) {
      clearTimeout(timer)
      timer = null;
    }

    message.value = msg;
    isVisible.value = true;

    timer = setTimeout(() => {
      isVisible.value = false
      timer = null
    }, duration)
  }

  defineExpose({
    show,
  })
</script>

<style lang="scss" scoped>
.toast-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 20px;
  border-radius: 3px;
  background-color: rgba(106, 108, 110, 0.95);
  box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.25);
  color: #FFF;
  margin: 10px;
}

.toast-text {
  flex-grow: 1;
  font-size: 13px;
}

.fade-enter-active, .fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter-from, .fade-leave-to {
  opacity: 0;
}
</style>